/* eslint-disable max-len */
export const CHANGE_INPUT = 'app/Settings/Security/CHANGE_INPUT';

export const CHANGE_STEP = 'app/Settings/Security/CHANGE_STEP';

export const CHECK_BIOMETRICS_AND_PIN_INFO = 'app/Settings/Security/CHECK_BIOMETRICS_AND_PIN_INFO';

export const DISABLE_ALT_AUTH_METHODS = 'app/Settings/Security/DISABLE_ALT_AUTH_METHODS';

export const DISABLE_BIOMETRIC_LOGIN = 'app/Settings/Security/DISABLE_BIOMETRIC_LOGIN';
export const DISABLE_BIOMETRIC_LOGIN_FAILURE = 'app/Settings/Security/DISABLE_BIOMETRIC_LOGIN_FAILURE';
export const DISABLE_BIOMETRIC_LOGIN_SUCCESS = 'app/Settings/Security/DISABLE_BIOMETRIC_LOGIN_SUCCESS';

export const DISABLE_PIN = 'app/Settings/Security/DISABLE_PIN';
export const DISABLE_PIN_FAILURE = 'app/Settings/Security/DISABLE_PIN_FAILURE';
export const DISABLE_PIN_SUCCESS = 'app/Settings/Security/DISABLE_PIN_SUCCESS';

export const FOCUS_INPUT = 'app/Settings/Security/FOCUS_INPUT';

export const ENABLE_BIOMETRIC_LOGIN = 'app/Settings/Security/ENABLE_BIOMETRIC_LOGIN';
export const ENABLE_BIOMETRIC_LOGIN_FAILURE = 'app/Settings/Security/ENABLE_BIOMETRIC_LOGIN_FAILURE';
export const ENABLE_BIOMETRIC_LOGIN_SUCCESS = 'app/Settings/Security/ENABLE_BIOMETRIC_LOGIN_SUCCESS';

export const RESET_DRAWER_INPUTS_AND_ERRORS = 'app/Settings/Security/RESET_DRAWER_INPUTS_AND_ERRORS';

export const RESET_STATE = 'app/Settings/Security/RESET_STATE';

export const SET_PIN = 'app/Settings/Security/SET_PIN';
export const SET_PIN_FAILURE = 'app/Settings/Security/SET_PIN_FAILURE';
export const SET_PIN_SUCCESS = 'app/Settings/Security/SET_PIN_SUCCESS';

export const UPDATE_BIOMETRICS_AND_PIN_INFO = 'app/Settings/Security/UPDATE_BIOMETRICS_AND_PIN_INFO';

export const UPDATE_ERROR = 'app/Settings/Security/UPDATE_ERROR';

// Messages
export const ACCOUNT_LOCKED_PIN_ERROR_MSG =
  'The user account is temporarily locked, try PIN authentication again later.';
export const ACCOUNT_LOCKED_BIOMETRIC_ERROR_MSG =
  'The user account is temporarily locked, try biometric authentication again later.';
export const BIOMETRICS_API_ERROR_MSG = 'Unable to authenticate. Please try again later.';
export const BIOMETRICS_DISABLED_ERROR_MSG = 'Biometric login is not enabled';
export const ENABLE_BIOMETRIC_LOGIN_ERROR_MSG =
  'Biometric login cannot be enabled at this time.';
export const PIN_LOCKED_ERROR_MSG =
  'PIN authentication is temporarily locked due to too many attempts.';

// Biometric labels based on Platform OS and supported authentication type(s) on a device.
export const BIOMETRIC_LABEL_DICTIONARY = {
  android: {
    face: 'Face Unlock',
    fingerprint: 'Fingerprint Authentication',
    iris: 'Iris Unlock',
    multiple: 'Biometric Authentication',
  },
  ios: {
    face: 'Face ID',
    fingerprint: 'Touch ID',
    /**
     * 'multiple' and 'iris' options don't exist on any current iOS devices. Leaving them in
     * 'just in case' and to keep similar shape as Android object.
     */
    iris: 'Biometric Authentication',
    multiple: 'Biometric Authentication',
  },
};

export const EDIT_PASSWORD_DICTIONARY = {
  desktop: {
    heading: 'Success!',
    subheading: 'Your password has been changed',
  },
};
